export class DocumentInclusion {
    subDocumentDesc: string;
 }
